// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"style_imgBox__1Ui8E","small":"style_small__1lFbY","middle":"style_middle__1LvDp","large":"style_large__3xDCy","img":"style_img__2TOeW"};